import { getKctGeneralStatus } from '../../services';
import useOverviewCheck from './useOverviewCheck';
import OverviewCardShell from './OverviewCardShell';

export default function KctGeneralCard() {
  const { data, isLoading, error } = useOverviewCheck(getKctGeneralStatus);

  return (
    <OverviewCardShell title="KCT General" isLoading={isLoading} error={error} good={data?.good}>
      {data && !data.error && (
        <div className="space-y-1 text-sm text-slate-700">
          {data.good ? (
            <p className="text-green-700">KCT đang chạy ổn định, không phát hiện vấn đề.</p>
          ) : (
            <>
              {data.text_to_video_error > 0 && (
                <p>⚠️ Text-To-Video kẹt <span className="font-bold">{data.text_to_video_error}</span> video</p>
              )}
              {data.tao_hang_loat_error > 0 && (
                <p>⚠️ Tạo hàng loạt kẹt <span className="font-bold">{data.tao_hang_loat_error}</span> bài</p>
              )}
            </>
          )}
        </div>
      )}
      {data?.error && <p className="text-sm text-red-600">{data.error}</p>}
    </OverviewCardShell>
  );
}
